import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { slugs } from "../../../Constant/slugs";
import { AdsGETApiAuth, AdsPUTApi } from "../../../Constant/api";
import DataTable from "react-data-table-component";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";

const columns = [
  {
    id: 1,
    name: "id",
    selector: (row) => row.id,
    sortable: true,
    reorder: true,
    width: "100px"
  },
  {
    id: 2,
    name: "Party Name",
    selector: (row) => row.meta.expense_title,
    sortable: true,
    reorder: true
  },
  {
    id: 2,
    name: "Title",
    selector: (row) => row.title.rendered,
    sortable: true,
    reorder: true
  },
  {
    id: 3,
    name: "Type",
    selector: (row) => row.meta.type,
    sortable: true,
    reorder: true
  },
  {
    id: 4,
    name: "Amount",
    selector: (row) => row.meta.amount,
    sortable: true,
    reorder: true
  },
  {
    id: 5,
    name: "TDS",
    selector: (row) => row.meta.tds,
    sortable: true,
    reorder: true
  },
  {
    id: 6,
    name: "Total",
    selector: (row) => row.meta.aftertds,
    sortable: true,
    reorder: true
  },
  {
    id: 7,
    name: "Date",
    selector: (row) => row.meta.payment_date,
    sortable: true,
    reorder: true
  },
  {
    id: 5,
    name: "Paid To",
    selector: (row) => row.meta.employee_name,
    sortable: true,
    reorder: true
  },
  {
    id: 6,
    name: "View",
    cell: (row) => <Link to={`${slugs.expenses_details}${row.slug}`}>View</Link>,

  }
];

export default function AllExpenses() {
  const [Projects1, setProjects1] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const [deleteUsersModal, setDeleteUsersModal] = React.useState(false)
  const [serachName, setSearchName] = React.useState("")
  const [TotalToday, setTotalToday] = React.useState("")
  const [Total, setTotal] = React.useState("")
  const [TotalTDS, setTotalTDS] = React.useState("")
  const [PaymentDate, setPaymentDate] = React.useState("")
  const [TotalWithTDS, setTotalWithTDS] = React.useState("")
  const dmyToIso = (date) => {
    const year = date.getFullYear()
    const month = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
    const day = date.getDate() < 9 ? `0${date.getDate()}` : `${date.getDate()}`
    return `${year}-${month}-${day}`
  };
  const date = new Date()

  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    console.log(dmyToIso(date))
    AdsGETApiAuth(
      {
        per_page: 10000,
        _fields: "id,title,slug,meta,date"
      }, slugs.db_slug_expenses)
      .then((res) => {
        setProjects1(res.data)
        setCustomersList(res.data)

        const ExpenseToday = res.data.filter(a => a.date.includes(dmyToIso(date)))
        var todayTotal = 0;
        for (let i = 0; i < ExpenseToday.length; i++)
          todayTotal += Number(ExpenseToday[i].meta.amount)
        setTotalToday(todayTotal)
        const ExpenseSelect = res.data
        var Total = 0, tds = 0, afterTDS = 0;
        for (let i = 0; i < ExpenseSelect.length; i++) {
          Total += Number(ExpenseSelect[i].meta.amount)
          tds += Number(ExpenseSelect[i].meta.tds)
          afterTDS += Number(ExpenseSelect[i].meta.aftertds)
        }
        setTotal(Total)
        setTotalTDS(tds)
        setTotalWithTDS(afterTDS)
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  useEffect(() => {
    GetAllProjects()
  }, [])




  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Expenses</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Expenses
        </div>
      </div>
      <a href={slugs.new_expenses}>
        <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}>
          Add New Expenses
        </div>
      </a>


      <div className="row">
        <div className="col-md-6">
          <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setCustomersList(Projects1)
              }}
            >
              All ({Projects1.length}) |
            </div>
          </div>
          {/* <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setDeleteUsersModal(Projects1)
              }}
            >
              Delete All
            </div>
          </div> */}
        </div>
        <div className="col-md-6 row">
          {/* <div className="col-6" /> */}
          <input className="col-4" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachName} placeholder="Name"
            onChange={(event) => {
              setSearchName(event.target.value)
              setCustomersList(Projects1.filter(a => a.title.rendered.toLowerCase().includes(event.target.value.toLowerCase()) || a.meta.expense_title.toLowerCase().includes(event.target.value.toLowerCase())))
            }}
          />
          {/* <input className="col-4" style={{ margin: "1px 2px", padding: "3px 2px" }}
            placeholder="Date" type="date"
            onChange={(event) => {
              // setSearchName(event.target.value)
              console.log(event.target.value)
              const ExpenseSelect = Projects1.filter(a => a.date.includes(event.target.value))
              setCustomersList(Projects1.filter(a => a.date.includes(event.target.value)))
              // var todayTotal = 0;
              // for (let i = 0; i < ExpenseSelect.length; i++){}
              //   todayTotal += Number(ExpenseSelect[i].meta.amount)
              // setTotal(todayTotal)
              var Total = 0, tds = 0, afterTDS = 0;
              for (let i = 0; i < ExpenseSelect.length; i++) {
                Total += Number(ExpenseSelect[i].meta.amount)
                tds += Number(ExpenseSelect[i].meta.tds)
                afterTDS += Number(ExpenseSelect[i].meta.aftertds)
              }
              setTotal(Total)
              setTotalTDS(tds)
              setTotalWithTDS(afterTDS)
            }}
          /> */}
          <div className="col-4">
            <div className="attendance-date-picker">
              <div className="small-nepali-datepicker"
              >
                {/* {item.date} */}
                <NepaliDatePicker style={{ cursor: "pointer" }}
                  placeholder={"date"}
                  value={PaymentDate || ""}
                  onChange={(selectedDate) => {
                    // setPaymentDate(selectedDate)
                    // // console.log(event.target.value)
                    // const ExpenseSelect = Projects1.filter(a => a.meta.payment_date.includes(selectedDate))
                    // setCustomersList(Projects1.filter(a => a.meta.payment_date.includes(selectedDate)))
                    // var todayTotal = 0;
                    // for (let i = 0; i < ExpenseSelect.length; i++)
                    //   todayTotal += Number(ExpenseSelect[i].meta.amount)
                    // setTotal(todayTotal)
                    // setSearchName(event.target.value)
                    const ExpenseSelect = Projects1.filter(a => a.meta.payment_date.includes(selectedDate))
                    setCustomersList(Projects1.filter(a => a.meta.payment_date.includes(selectedDate)))
                    // var todayTotal = 0;
                    // for (let i = 0; i < ExpenseSelect.length; i++){}
                    //   todayTotal += Number(ExpenseSelect[i].meta.amount)
                    // setTotal(todayTotal)
                    var Total = 0, tds = 0, afterTDS = 0;
                    for (let i = 0; i < ExpenseSelect.length; i++) {
                      Total += Number(ExpenseSelect[i].meta.amount)
                      tds += Number(ExpenseSelect[i].meta.tds)
                      afterTDS += Number(ExpenseSelect[i].meta.aftertds)
                    }
                    setTotal(Total)
                    setTotalTDS(tds)
                    setTotalWithTDS(afterTDS)
                  }
                  }
                  options={{
                    calenderLocale: "ne",
                    valueLocale: "en",
                  }}
                  placeholder="मिति छान्नुहोस्"
                // onSelect={() => { setOpencalendar(true) }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        Total Today:{TotalToday}&nbsp;
        Total Selected:{Total}&nbsp;
        Total TDS:{TotalTDS}&nbsp;
        Total Without TDS:{TotalWithTDS}&nbsp;
      </div>
      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <DataTable
          columns={columns}
          data={CustomersList}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          paginationPerPage={100}
          paginationRowsPerPageOptions={[10, 50, 100, 1000]}
          pagination
          selectableRows
        />
      </div>
      {deleteUsersModal &&
        <section className="modal" >
          <div className="row" style={{ overflow: "hidden" }}>
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setDeleteUsersModal(false)
                  }}
                >X</div>
                Do you really want to Delete all the expenses?<br />
                <div className="row">
                  <div className="col-3 center " >
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        setDeleteUsersModal(false)
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div className="col-3 center">
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        for (let i = 0; i < Projects1.length; i++) {
                          setReload(true)
                          setDeleteUsersModal(false)
                          AdsPUTApi({
                            status: "draft"
                          }, slugs.db_slug_expenses, Projects1[i].id)
                            .then((res) => {
                              if (i == Projects1.length - 1) {
                                GetAllProjects()
                              }
                            })
                            .catch((err) => {
                              console.log(err)
                            })

                        }
                      }}
                    >
                      Delete all Expenses
                    </div>
                  </div>
                </div>
                <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px", border: "1px solid #999" }}>
                  <DataTable
                    paginationPerPage={100}
                    paginationRowsPerPageOptions={[10, 50, 100, 1000]}
                    columns={columns}
                    data={Projects1}
                    defaultSortFieldId={1}
                    defaultSortAsc={false}
                    striped
                    // sortIcon={<SortIcon />}
                    pagination
                    selectableRows={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

      }
      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div>
  )
}